import { OpenType } from "@q/softCore";

interface IStatus {
  [key: number]: string;
}

export const statusText: IStatus = {
  0: "安装", // download
  1: "正在下载", // downloading
  2: "正在安装", // installing
  3: "继续下载", // download-pause
  4: "立即开启", // install-success
  5: "正在下载", // wait-download
  6: "安装", // download-cancel
  7: "安装", // download-success
  8: "重新下载", // download-failed
  9: "安装", // install-cancel
  10: "安装", // install-failed
  11: "升级", // upgrade
  12: "一键安装", // one-key-inst
  13: "一键升级", // one-key-upgrade
  14: "正在安装", // installing
  15: "已收藏", // collect-success
  16: "收藏", // conllect-failed
  17: "等待安装", // wait-install
  18: "已安装", // open-failed
  19: "安装", // pure-inst
  20: "升级", // pure-update
};

export const monitorStText: IStatus = {
  0: "下载", // download
  12: "下载",
  19: "下载",
  7: "下载完成",
};

export const statusClassName: IStatus = {
  0: "",
  1: "underway",
  2: "underway",
  3: "",
  4: "open",
  5: "underway",
  6: "",
  7: "",
  8: "",
  9: "",
  10: "",
  11: "upgrade",
  12: "",
  13: "upgrade",
  14: "underway",
  15: "collect",
  16: "collect",
  17: "underway",
  18: "disabled",
  19: "",
  20: "upgrade",
};

export const openTypeText = {
  [OpenType.openWithBrowser]: "立即开启",
  [OpenType.openWithClient]: "立即开启",
  [OpenType.openDetailInHome]: "查看详情",
  [OpenType.openDetailInDetail]: "查看详情",
  [OpenType.download]: "立即下载",
  [OpenType.openAppWithCmd]: "立即开启",
  [OpenType.execCmdWithClient]: "立即开启",
  [OpenType.goToGameTab]: "立即开启",
  [OpenType.softBuy]: "立即购买",
};

export const comBannerShowIds = [
  "AZ2q3f",
  "LaKMxE",
  "rIotJv",
  "f1Fia3",
  "VJhEA5",
  "MG0acw",
  "C28GoB",
  "eOLdkS",
];
export const comSpecial1Ids = ["Lioq9Q", "KIaLpZ", "xIJc8f"];
export const comRankIds = ["boD51i", "239uNL", "7fsSve", "2vALxV"];
export const comAdId = ["la91VA"];
export const comTabHotIds = [
  "l8B3Tb",
  "qZtq0a",
  "W3gQr7",
  "pGFiuL",
  "AOrGXx",
  "YoU9o8",
  "mIxjE7",
  "BBB7KE",
  "nWGLMR",
  "p25NX5",
  "hpUPSD",
  "TYi6Aj",
];
export const comTabOfficeIds = [
  "zmFUpk",
  "nANM5M",
  "gJIUw5",
  "LDCYWG",
  "2zl7m2",
  "K4Gt2Q",
  "judwYS",
  "Td3jdX",
  "D0csRV",
  "Po3C4J",
  "kSMpG6",
  "3cEJ2j",
];
export const gameBannerIds = [
  "TUsSF4",
  "9Ui1i9",
  "vtvZ10",
  "mt7kdi",
  "o2kh6J",
  "MIKkgi",
];
export const gameTabLine = ["Nu1cw1", "rv6C9o", "Wvu5xy", "GO1S6I"];
export const gameTabNetWork = [
  "k8vgkc",
  "4FQQ1a",
  "H93Xo0",
  "7Ly1kE",
  "zFc781",
];
export const gameAdId = ["jMseiz"];
